import styled from 'styled-components';

const GlobeImg = styled.img`
  height: 20px;
  width: 20px;
  margin-right: 25px;
`;

export default GlobeImg;
